import 'swiper/css'
import 'swiper/css/navigation'
import dynamic from 'next/dynamic'
const ProductCollectionSwiper = dynamic(
  () => import('@components/home/ProductCollectionSwiper')
)

const BannerBackground = ({
  data,
  collection,
  bannerColor,
  deviceInfo,
  type,
  viewType,
  redirectionUrl,
  cmsNoPaddingLayout,
}: any) => {
  const _data = data?.[type]
  const title = _data?.[0]?.[`${type}_title`] ?? ''
  return (
    <div className={`relative mt-0 py-3 bg-white home-banner-swiper-colletion`}>
      <ProductCollectionSwiper
        data={collection}
        deviceInfo={deviceInfo}
        title={title}
        viewType={viewType}
        redirectionUrl={redirectionUrl}
        cmsNoPaddingLayout={cmsNoPaddingLayout}
      />
    </div>
  )
}

export default BannerBackground
